import { useEffect, useState } from "react";
import { API } from "../../API";
import moment from "moment";
import {bookingBarDataMake} from "./Charts/barChart"
const useStatistics = (props) => {
  const [customers, setCustomers] = useState([]);
  const [bookingReport,setBookingReport] = useState({})
  const [bookingReportOptions,setBookingReportOptions] = useState([])
  const [bookingStateReport,setBookingStateReport] = useState({})
  const [bookingStateReportHrs,setBookingStateReportHrs] = useState({})
  

  const [states, setStates] = useState([])
  const [bookingBarData, setbookingBarData] = useState({})
  const [bookingBarOpt, setbookingBarOpt] = useState()

  const [barChartLabels, setBarChartLabels] = useState(states);
  const [bookingReportKeys , setBookingReportKeys] = useState([])
  const [bookingReportMonths , setBookingReportMonths] = useState([])

  const [userAll,setUserAll] = useState({})
  const [userPieData,setUserPieData] = useState()
  const [userStateOption,setUserStateOption] = useState([])
  const [userItemOption,setUserItemOption] = useState([])

  const [morningET,setMorningET] = useState({})
  const [autoAllocate,setAutoAllocate] = useState({})

  const [etPie,setETPie] = useState({})
  const [etPieOpt,setETPieOpt] = useState()
  const [etPieOptions,setETPieOptions] = useState([])
  
  const [unassigned,setunassigned] = useState()
  const [unassignedState,setunassignedState] = useState()

  const [avaTeacher,setavaTeacher] = useState()
  const [avaTeacherState,setavaTeacherState] = useState()

  const [todayTable,settodayTable] = useState({})

  const [activeStateC,setactiveStateC] = useState('total')
  const [statesC,setstatesC] = useState([])
  const [statesT,setstatesT] = useState([])
  const [activeStateT,setactiveStateT] = useState('total')
  const [activeData,setactiveData] = useState({})

  const [newReg,setnewReg] = useState([])
  const [newRegView,setnewRegView] = useState([])
  const [newRegTView,setnewRegTView] = useState('ELICOS/VET')
  
  const getAllCustomers = async () => {
    try {
      const { data } = await API.allCustomers();
      setCustomers(
        data
          ?.filter((customer) => customer?.institution_id?.institution_name)
          ?.map((customer) => customer?.institution_id?.institution_name)
      );
    } catch (error) {
      console.log(error);
    }
  };
  const getUnassigned = async () => {
    try {
      const { data } = await API.unassignedBook();
      let total = 0
      let states = []
      for(let key in data.data){
        total += data.data[key]
        if(Number(data.data[key]) > 0 ){
          states.push(key)
        }
      }
      setunassigned(total)
      setunassignedState(states.join(', '))
    } catch (error) {
      console.log(error);
    }
  };
  const getAvaTeacher = async () => {
    try {
      const { data } = await API.avaTeacher();
      let total = 0
      let amStates = [];
      let pmStates = [];
      for(let key in data.data){
        const stateData = data.data[key];
        const stateTotal = stateData.AM + stateData.PM;
        total += stateTotal;
        amStates.push(`${key}: ${stateData.AM}`);
        pmStates.push(`${key}: ${stateData.PM}`);
      }
      setavaTeacher(total)
      setavaTeacherState(data.data)
      // setavaTeacherState(`AM: ${amStates.join(', ')}, PM: ${pmStates.join(', ')}`)
    } catch (error) {
      console.log(error);
    }
  };
  const getBookingReport = async (start,end) =>{
    try {
      const {data} = await API.bookingReport(start,end)
      if(Object.keys(data.data).length === 0) { 
        return getBookingReport(redMon(start),end) 
      }
      setBookingReport(data.data)
      setStates(Object.keys(data.data))
      let newKeys = []
      for(let item in data.data['VIC']){
        newKeys.push(item)
      }
      setBookingReportKeys(newKeys)
      let options = Object.keys(data.data['VIC']).filter(key => typeof data.data['VIC'][key] === 'object')
      setBookingReportOptions(options)
      let dataset = await bookingBarDataMake(data.data)
      setbookingBarData(dataset)
      setbookingBarOpt('teachers')
    } catch (error) {
      console.log('getBookingReport ERR',error);
    }
  }
  const getTodayReport = async () =>{
    try {
      function getNextWorkingDays(count) {
      const workingDays = [];
      let currentDate = moment();
      
      while (workingDays.length < count) {
        if (currentDate.day() >= 1 && currentDate.day() <= 5) { // Monday (1) to Friday (5)
          workingDays.push(currentDate.format('YYYY-MM-DD'));
        }
        currentDate.add(1, 'day');
      }
      return workingDays;
      }
      const start = moment().format('YYYY-MM-DD');
      const endWorkingDays = getNextWorkingDays(7);
      const end = endWorkingDays[6];
      const {data} = await API.bookingStat(start,end);
      const data0 = data.data.day
      const dates = Object.keys(data0.state)
      let table = {}
      for(let date of dates){
        if(date >= start && date <= end){
        table[date] = {}
        table[date].booking = data0.booking[date]
        table[date].hours = data0.paid[date]
        table[date].morning = data0.time[date].Morning || 0
        table[date].afternoon = data0.time[date].Afternoon || 0
        table[date].evening = data0.time[date].Evening || 0
        table[date].VIC = data0.state[date].VIC || 0
        table[date].NSW = data0.state[date].NSW || 0
        table[date].QLD = data0.state[date].QLD || 0
        table[date].WA = data0.state[date].WA || 0
        table[date].SA = data0.state[date].SA || 0
        }
      }
      settodayTable(table)
    } catch (error) {
      console.log('getBookingReport ERR',error);
    }
  }
  
  const getTopTen = async (start,end) =>{
    start = start ? start : moment().startOf('month').format('YYYY-MM-DD')
    end = end ? end : moment().endOf('month').format('YYYY-MM-DD')
    try {
      const {data} = await API.topTen(start,end);
      const stateC = Object.keys(data.data.customer)
      const stateT = Object.keys(data.data.teacher)
      setactiveData(data.data)
      setstatesC(stateC)
      setstatesT(stateT)
    } catch (error) {
      console.log('getTopTen ERR',error);
    }
  }
  const getNewReg = async () =>{
    try{
      const {data} = await API.newReg();
      setnewReg(data.data)
      await newRegWeek('4+ Weeks',data.data)
    }catch (error){
      console.log('newReg',error)
    }
  }
  const getMorningETReport = async (start,end) =>{
    try {
      const {data} = await API.morningETReport(start,end)
      if(Object.keys(data.data.morningET).length === 0) { 
        return getMorningETReport(redMon(start),end) 
      }
      setETPie(data)
      setETPieOptions(Object.keys(data.data))
      setETPieOpt('morningET')
      setMorningET(data.data.morningET)
      setAutoAllocate(data.data.AutoAllocate)
    } catch (error) {
      console.log('getMorningETReport ERR',error);
    }
  }
  const getBookingStateReport = async () =>{
    try {
      const {data} = await API.bookingStateReport()
      setBookingStateReport(data.data.count)
      setBookingStateReportHrs(data.data.hours)
    } catch (error) {
      console.log('getBookingStateReport ERR',error);
    }
  }
  const teacherReport = async () =>{
    try {
      const {data} = await API.teacherReport()
      setUserItemOption(Object.keys(data.data.user.statistic))
      setUserAll(data.data.user)
      setUserStateOption(['All', ...Object.keys(data.data.user.statistic.registered)])
      setUserPieData('is_searchable')
    } catch (error) {
      console.log('teacherReport ERR',error);
    }
  }
  function getAllMonthAbbreviations(startMonthAbbreviation) {
    const currentMonth = moment();
    const startMonth = moment(startMonthAbbreviation, 'MMM');

    if (!startMonth.isValid() || startMonth.isAfter(currentMonth)) {
      return []; // Return an empty array if the start month is invalid or in the future.
    }

    const monthAbbreviations = [];
  let current = currentMonth.clone().subtract(12, 'months');

  for (let i = 0; i < 15; i++) {
    monthAbbreviations.push(current.format('MMM-YYYY').toUpperCase());
    current.add(1, 'month');
  }


    return monthAbbreviations;
  }
  const bookingReportMonth = () =>{
    setBookingReportMonths(getAllMonthAbbreviations('JAN'))
  }
  const handleChangeBarchartStates = (e, values) => {
    if (values?.length) {
      setBarChartLabels(values);
    } else {
      setBarChartLabels(states);
    }
  };
  const handleChangeUserPie = (e, values) => {
    if (values?.length) {
      setUserPieData(values)
    } else {
      setUserPieData('registered')
    }
  };
  const handleChangeETPie = (e, values) => {
    if (values?.length) {
      setETPieOpt(values);
    } else {
      setETPieOpt('morningET');
    }
  };
  const handleChangeReport = (e, values) => {
    if (values?.length) {
      setbookingBarOpt(values);
    } else {
      setbookingBarOpt('teachers');
    }
  };
  const handleChangeState = (e, values) => {
    if (values?.length) {
      setETPieOpt(values);
    } else {
      setETPieOpt('morningET');
    }
  };
  const handleChangeUserPieState = (e, values) => {
    if (values?.length && values != 'All') {
      let newPieData = userAll.other
      setUserAll(newPieData);
      setUserItemOption(Object.keys(newPieData[values]))
      setUserPieData(Object.keys(newPieData[values])[0])
    } else {
      teacherReport()
    }
  };
  const handleChangeBookingReportMont = (e, values) => {
    const month = values.split('-')[0]
    const year = values.split('-')[1]
    const startDate = moment(`${year}-${month}-01`);
    const endDate = moment(startDate).endOf('month');
    const formattedStartDate = startDate.format('YYYY-MM-DD');
    const formattedEndDate = endDate.format('YYYY-MM-DD');
    getBookingReport(formattedStartDate,formattedEndDate)
  };
  const handleChangeETReportMont = (e, values) => {
    const month = values.split('-')[0]
    const year = values.split('-')[1]
    const startDate = moment(`${year}-${month}-01`);
    const endDate = moment(startDate).endOf('month');
    const formattedStartDate = startDate.format('YYYY-MM-DD');
    const formattedEndDate = endDate.format('YYYY-MM-DD');
    getMorningETReport(formattedStartDate,formattedEndDate)
  };
  const changeTopTenStateC = (e, values) => {
    if (values?.length) {
      setactiveStateC(values)
    } else {
      setactiveStateC('total')
    }
  };
  const changeTopTenStateT = (e, values) => {
    if (values?.length) {
      setactiveStateT(values)
    } else {
      setactiveStateT('total')
    }
  };
  const changeTopTenMonth = (e, values) => {
    const month = values.split('-')[0]
    const year = values.split('-')[1]
    const startDate = moment(`${year}-${month}-01`);
    const endDate = moment(startDate).endOf('month');
    const formattedStartDate = startDate.format('YYYY-MM-DD');
    const formattedEndDate = endDate.format('YYYY-MM-DD');
    getTopTen(formattedStartDate,formattedEndDate)
  };
  const updateCheckbox = (item,value,index)=>{
    console.log(item,value,index)
  }

  const redMon = (date) => {
    return moment(date).subtract(1, 'months').format('YYYY-MM-DD')
  }
  const newRegWeek = async (e, data) => {
    try{
      data = data ? data : newReg
    const opt = ['1 Week Ago','2 Weeks Ago','3 Weeks Ago','4+ Weeks Ago'].indexOf(e) + 1
    const start = moment().subtract((opt) * 7, 'days').format('YYYY-MM-DD');
    const end = moment().subtract((opt-1) * 7, 'days').format('YYYY-MM-DD');
    const result = data.filter(obj => {
      const objDate = moment(obj.registration_date).format('YYYY-MM-DD');
      if(moment(objDate).isSameOrAfter(start) && moment(objDate).isBefore(end)){
        return obj
      }
    });
    setnewRegView(result)
    }catch (error) {
      console.log('newRegWeek', error);
    }
  };
  const newRegType = async (e, velues) => {
    try{
    setnewRegTView(e)
    }catch (error) {
      console.log('newRegWeek', error);
    }
  };
  useEffect(() => {
    getTopTen();
    getAllCustomers();
    getBookingReport(
      moment().startOf('month').format('YYYY-MM-DD'),
      moment().format('YYYY-MM-DD')
    );
    getBookingStateReport();
    bookingReportMonth();
    teacherReport();
    getMorningETReport(
      moment().startOf('month').format('YYYY-MM-DD'),
      moment().format('YYYY-MM-DD')
    );
    getTodayReport();
    getUnassigned();
    getAvaTeacher();
    getNewReg();
  }, []);

  return {
    states,
    customers,
    barChartLabels,
    bookingReport,
    bookingStateReport,
    bookingStateReportHrs,
    bookingReportKeys,
    bookingReportOptions,
    bookingReportMonths,
    userAll,
    userPieData,
    userItemOption,
    userStateOption,
    morningET,
    autoAllocate,
    etPie,
    etPieOpt,
    etPieOptions,
    handleChangeBarchartStates,
    handleChangeUserPie,
    handleChangeUserPieState,
    handleChangeETPie,
    handleChangeUserPieState,
    handleChangeBookingReportMont,
    handleChangeETReportMont,
    bookingBarData,
    bookingBarOpt,
    handleChangeReport,
    handleChangeState,
    unassigned,
    unassignedState,
    avaTeacher,
    avaTeacherState,
    todayTable,
    activeStateC,
    activeStateT,
    activeData,
    statesC,
    statesT,
    changeTopTenStateC,
    changeTopTenStateT,
    changeTopTenMonth,
    updateCheckbox,
    newReg,
    newRegView,
    newRegTView,
    newRegWeek,
    newRegType,
    ...props,
  };
};

export default useStatistics;
